import { render, staticRenderFns } from "./Mywatch.vue?vue&type=template&id=1260f114&scoped=true&"
import script from "./Mywatch.vue?vue&type=script&lang=js&"
export * from "./Mywatch.vue?vue&type=script&lang=js&"
import style0 from "./Mywatch.vue?vue&type=style&index=0&id=1260f114&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1260f114",
  null
  
)

export default component.exports